module.exports = __webpack_public_path__ + "media/styles/images/svg/circle-check-teal-on-white-b1f28eaaa1183261696b8fd366fb101b.svg";